module.exports = __webpack_public_path__ + "static/3-693a957d2751dcb03f1973fd6971bde5.jpg";